import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/empty.png'


const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "page-inner page-left" }
const _hoisted_3 = { class: "correct-title" }
const _hoisted_4 = { style: {"color":"#ef8b25"} }
const _hoisted_5 = { class: "upload-inner" }
const _hoisted_6 = { style: {"margin":"20px 0"} }
const _hoisted_7 = { class: "page-inner page-right" }
const _hoisted_8 = {
  key: 0,
  class: "page-box-title2 title1"
}
const _hoisted_9 = {
  key: 1,
  class: "page-box-correct"
}
const _hoisted_10 = { class: "page-box-correct-btn" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = {
  key: 2,
  class: "page-inner-box"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 4,
  class: "page-inner-box empty"
}

import { fetchEventSource } from '@microsoft/fetch-event-source';
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { compEvalStreamingV2, saveSreamResult, compTeachEvalStreamingV2, compExamEvalStreamingV2, checkAiCall, compPictureStreaming, getVoiceDataOss, html2Pdf } from "@/api/composition.js"
import { uploadImg, delImgApi } from "@/api/common.js"
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import AIpopup from "./components/AIpopup.vue";
import Speech from 'speak-tts'
import { useRoute } from 'vue-router';
import { useStore } from "vuex"

export default /*@__PURE__*/_defineComponent({
  __name: 'correctPage',
  setup(__props) {

const route = useRoute()
const store = useStore();
const correctType = [
    {
        label: '常规评阅',
        value: '01'
    },
    {
        label: '教学评阅',
        value: '02'
    },
    {
        label: '考试评阅',
        value: '03'
    }
]
const tabArr = [
    {
        label: '评阅结果',
        value: '01'
    },
    {
        label: '总评得分',
        value: '02'
    },
    {
        label: '修改建议',
        value: '03'
    },
    {
        label: '原图批改',
        value: '04'
    },
]
const tabList = ref([])
const activeName = ref('')
const formData = ref({
    correctTitle: '',
    correctType: '01',
    correctText: ''
})
const fileList = ref([])
const showPreview = ref(false)
const previewIndex = ref(0)
const previewFileArr = ref([])
let fileArr = []
let controller = null
let aiMessage = ref('')
let resultInfo = ref({})
const aiStart = ref(false)
const formPage = ref('')
const popupShow = ref(false)
const compImg = ref([])
const voiceStatus = ref(0) //1 语音正在播放 2语音暂停 0没有语音 4语音播放完成
const speech = new Speech();
let timeFlag = 0
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
let resultNum = {}, currentKey = '', regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
const correctImgShow = ref(false);
const correctImgLoading = ref(false);

function aiCancel() {
    aiStart.value = false;
    popupShow.value = false;
    controller && controller.abort()
}
function submitEvent() {
    speech.cancel()
    const { correctTitle, correctType, correctText } = formData.value;
    if (!correctTitle) {
        return ElMessage.warning('请填写作文标题');
    }
    if (!correctText && !fileList.value.length) {
        return ElMessage.warning('请填写作文文本或拍摄作文');
    }

    if (correctType == '01') {
        tabList.value = [
            {
                label: '评阅结果',
                value: '01'
            },
        ]
    } else if (['02', '03'].includes(correctType)) {
        tabList.value = [
            {
                label: '总评得分',
                value: '02'
            },
            {
                label: '修改建议',
                value: '03'
            },
        ]
    }
    // if (fileList.value.length) {
    //     tabList.value.push({ label: '原图批改', value: '04' })
    // }
    activeName.value = tabList.value[0].value
    checkAiCall().then(res => {
        if (res.data.result) {
            ElMessageBox.confirm(
                `今日AI调用频繁，已超过${res.data.num}次`,
                '温馨提示',
                {
                    confirmButtonText: '继续用',
                    type: 'warning',
                    showCancelButton: false
                }
            ).then(() => {
                getAi()
            })
        } else {
            getAi()
        }
    })
}

function getAi() {
    const { correctTitle, correctType, correctText } = formData.value;
    const params = {
        grade: sessionStorage.getItem("grade"),
        term: sessionStorage.getItem("term"),
        title: correctTitle,
        text: correctText || '',
        fileIds: fileArr.map(item => {
            return item.fileId
        }).join(','),
    }
    let api;
    switch (formData.value.correctType) {
        case '02':
            api = compTeachEvalStreamingV2
            break;
        case '03':
            api = compExamEvalStreamingV2
            break;
        default:
            api = compEvalStreamingV2
            break;
    }
    aiStart.value = true
    popupShow.value = true
    voiceStatus.value = 0;
    fetchRequest({
        url: api,
        aiParam: params,
        timeFlag: new Date().getTime()
    })
    compImg.value = []
    correctImgShow.value = false;
    correctImgLoading.value = true;
    if (fileArr.length) {
        compPictureStreaming({
            fileIds: fileArr.map(item => {
                return item.fileId
            }).join(','),
        }).then(res => {
            if (res.data) {
                compImg.value = res.data;
            }
            correctImgShow.value = true;
            correctImgLoading.value = false;
        }).catch(() => {
            correctImgShow.value = true;
            correctImgLoading.value = false;
        })
    } else {
        correctImgShow.value = true;
        correctImgLoading.value = false;
    }
}

async function fetchRequest(params) {
    if (timeFlag == params.timeFlag) return;
    timeFlag = params.timeFlag;
    controller = new AbortController()
    const { signal } = controller;
    aiMessage.value = ''
    resultInfo.value = {}
    resultNum = {}
    currentKey = ''
    const response = await fetch(params.url, {
        signal,
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem("token"),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params.aiParam)
    })
    popupShow.value = false;
    if (!response.ok) {
        try {
            const errorData = await response.join()
            aiStart.value = false
            return ElMessage.warning(errorData.message || '请求失败')
        } catch (error) {
            console.log(error)
            aiStart.value = false
            return ElMessage.warning('请求失败')
        }
    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let done = false;
    let obj = {}
    let str = ''
    while (!done) {
        const {
						done: readerDone,
            value
					} = await reader.read()
        done = readerDone;

        if (value) {
            const chunkText = decoder.decode(value, {
                stream: !done
            })
            const lines = chunkText.split('\n')
            let isMessage = true;
            lines.forEach(line => {
                console.log(line)
                if (line.indexOf('Done') > -1) {
                    isMessage = false;
                    aiStart.value = false
                }
                if (line.indexOf('Error') > -1) {
                    isMessage = false;
                    aiStart.value = false;
                    return ElMessage.warning('AI调用失败，请稍后再试！');
                }
                if (line.indexOf('"500"') > -1) {
                    isMessage = false;
                    aiStart.value = false;
                    let errorMsg = JSON.parse(line).msg;
                    return ElMessage.warning(errorMsg || 'AI调用失败，请稍后再试！');
                }
                if (isMessage && line.indexOf('content') > -1) {
                    let jsonString = '';
                    if (line.startsWith('data:')) {
                        jsonString = line.substring(5).trim();
                    } else {
                        jsonString = line
                    }

                    if (jsonString) {
                        try {
                            const jsonData = JSON.parse(jsonString)
                            if (jsonData ?.node_type == 'End') {
                                console.log('node_is_finish')
                                return
                            }
                            const content = (jsonData ?.content || '');
                            if (content) {
                                str += content
                                const matches = content.match(regex) || [];
                                let resultArr = matches.filter(match => match !== '');
                                resultArr.forEach(info => {
                                    if (romanNumerals.includes(info)) {
                                        if (info in resultNum) {
                                            resultNum[info] = resultNum[info] + 1;
                                            resultInfo.value[info].push('');
                                        } else {
                                            resultNum[info] = 1;
                                            resultInfo.value[info] = [''];
                                        }
                                        currentKey = info;
                                    } else if (currentKey in resultInfo.value) {
                                        if (resultNum[currentKey] == 1) {
                                            resultInfo.value[currentKey][resultNum[
                                                currentKey] - 1] += info.replace(/^\s+/, "").replace(/\n+/g, '<br/>');
                                        } else {
                                            resultInfo.value[currentKey][resultNum[
                                                currentKey] - 1] += info.replace(/\n+/g, '<br/>');
                                        }

                                    }
                                })
                                console.log(resultInfo.value)
                                aiMessage.value = str
                            }
                        } catch (error) {
                            console.log(error)
                            aiStart.value = false
                            return ElMessage.warning('AI调用失败，请稍后再试！');
                        }
                    }
                }
            })
        } else {
            aiStart.value = false;
        }
    }
}

function httpRequest(params) {
    const fileInfo = new FormData()
    fileInfo.append('file', params.file)
    const loading = ElLoading.service({
        lock: true,
        background: 'rgba(0, 0, 0, 0.5)',
    })
    uploadImg(fileInfo).then(res => {
        fileArr.push(res.data)
        previewFileArr.value.push(res.data.fileUrl)
        fileList.value[fileList.value.length - 1]['fileId'] = res.data.fileId;
    }).finally(() => {
        loading.close()
    })
}

function handlePictureCardPreview(file) {
    previewIndex.value = fileArr.findIndex(item => {
        return item.fileId == file.fileId
    })
    showPreview.value = true;
}

function handleRemove(file) {
    if (file.fileId) {
        const index = fileArr.findIndex(item => {
            return item.fileId == file.fileId
        })
        // delImgApi(file.fileId).then(res => {
        ElMessage.success('删除成功')
        fileArr.splice(index, 1)
        previewFileArr.value.splice(index, 1)
        // })
    }
}

function dataFormat(type) {
    const correctType = formData.value.correctType;
    switch (type) {
        case 'Ⅰ':
        case 'Ⅱ':
        case 'Ⅲ':
            return correctType == '01' || (['02', '03'].includes(correctType) && activeName.value == '02')
        case 'Ⅳ':
            return correctType == '01' || (['02'].includes(correctType) && activeName.value == '03') || (['03'].includes(correctType) && activeName.value == '02')
        case 'Ⅴ':
        case 'Ⅵ':
            return correctType == '01' || (['02', '03'].includes(correctType) && activeName.value == '03')
        default:
            return false;
    }
}

function transVoice() {
    if (aiStart.value) {
        return ElMessage.warning('独家算法，请稍等！');
    }
    if (voiceStatus.value == 1) {
        speech.pause()
        voiceStatus.value = 2
        return
    }
    if (voiceStatus.value == 2) {
        speech.resume()
        voiceStatus.value = 1
        return
    }
    if (Object.keys(resultInfo.value).length) {
        let text = ''
        const loading = ElLoading.service({
            lock: true,
            text: '语音即将播放！',
            background: 'rgba(255, 255, 255, 0.7)',
        })
        const keys = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ"];
        keys.forEach(key => {
            if (key in resultInfo.value && resultInfo.value[key].length) {
                resultInfo.value[key].forEach((item, index) => {
                    text += item.replace(/<br\/>/g, '。').replace(
                        /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu,
                        '')
                    if (key == 'Ⅵ') {
                        if (resultInfo.value.Ⅶ && resultInfo.value.Ⅶ.length >= resultInfo.value.Ⅵ
                            .length) {
                            text += resultInfo.value.Ⅶ[index].replace(/<br\/>/g, '。').replace(
                                /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu,
                                '')
                        }
                        if (resultInfo.value.Ⅷ && resultInfo.value.Ⅷ.length >= resultInfo.value.Ⅵ
                            .length) {
                            text += resultInfo.value.Ⅷ[index].replace(/<br\/>/g, '。').replace(
                                /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu,
                                '')
                        }
                    }
                })
            }
        })

        speech.speak({
            text: text,
            listeners: {
                onstart: () => {
                    loading.close()
                    voiceStatus.value = 1;
                },
                onend: () => {
                    voiceStatus.value = 4
                }
            }
        });
    }
}

function resultTabChange(val) {
    speech.cancel()
    voiceStatus.value = 0
}

function exportEvent() {
    if (aiStart.value) {
        return ElMessage.warning('独家算法，请稍等！');
    }
    // if (!correctImgShow.value) {
    //     return ElMessage.warning('图片批改中，请稍等！');
    // }
    const keys = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ"];
    let text = ''
    keys.forEach(key => {
        if (key in resultInfo.value && resultInfo.value[key].length) {
            resultInfo.value[key].forEach((item, index) => {
                text += `<div>${item}</div>`
                if (key == 'Ⅵ') {
                    if (resultInfo.value.Ⅶ && resultInfo.value.Ⅶ.length >= resultInfo.value.Ⅵ.length) {
                        text += `<div>${resultInfo.value.Ⅶ[index]}</div>`
                    }
                    if (resultInfo.value.Ⅷ && resultInfo.value.Ⅷ.length >= resultInfo.value.Ⅵ.length) {
                        text += `<div>${resultInfo.value.Ⅷ[index]}</div>`
                    }
                }
            })
        }
    })

    html2Pdf({
        content: text,
        picUrlList: compImg.value || []
    }).then(res => {
        console.log(res)
        let temp = document.createElement('a') // 创建a标签
        temp.download = '评阅结果.pdf'// 设置下载名称
        temp.href = res.data;

        // 手动触发点击事件
        temp.click()
    })
}

onBeforeUnmount(() => {
    controller && controller.abort()
    speech && speech.cancel()
})

onMounted(() => {
    formPage.value = route.query.page;
    speech.init({
        volume: 1,
        lang: 'zh-CN',
        rate: 1.4,
        pitch: 1.4,
    }).then(() => {
        console.log('语音引擎初始化成功');
    });
})

return (_ctx: any,_cache: any) => {
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Camera = _resolveComponent("Camera")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Microphone = _resolveComponent("Microphone")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "page-box-title title1" }, " 作文批阅 ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createTextVNode("包含常规评阅、教学评阅、考试评阅三种评阅方式，均采用三步九法思想进行评阅，各自评阅标准不同。 ")),
        _createVNode(_component_el_popover, {
          placement: "right-start",
          trigger: "click",
          width: "300"
        }, {
          reference: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, [
              _cache[6] || (_cache[6] = _createTextVNode("了解区别 ")),
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_QuestionFilled)
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "distinction-box" }, [
              _createElementVNode("div", { class: "distinction-box-title" }, "一、常规评阅"),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, "日常作文水平快速诊断"),
                _createElementVNode("div", null, "• 按50分制综合打分，给出等级评定。"),
                _createElementVNode("div", null, "• 快速判断作文整体质量，适合日常练习、课后作业的整体评估。")
              ]),
              _createElementVNode("div", { class: "distinction-box-title" }, "二、考试评阅"),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, "对标小/中/高考考场标准"),
                _createElementVNode("div", null, "• 严格按照官方考试评分细则分项打分。"),
                _createElementVNode("div", null, "• 明确标注扣分项、得分点，提前适配考场规则，用于模拟考试、考前冲刺训练。")
              ]),
              _createElementVNode("div", { class: "distinction-box-title" }, "三、教学评阅"),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, "逐句精批+针对性教学指导"),
                _createElementVNode("div", null, "• 逐句批注，精准指出病句、错别字、逻辑漏洞、表达问题。"),
                _createElementVNode("div", null, "• 给出详细修改建议与优化方向，侧重教学辅导，帮助学生逐点改正、提升写作能力。")
              ])
            ], -1))
          ]),
          _: 1,
          __: [7]
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 14 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.correctTitle,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.correctTitle) = $event)),
                  placeholder: "请填写作文标题（必填项）",
                  maxlength: "50"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.correctType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.correctType) = $event)),
                  placeholder: "请选择评阅方式"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(correctType, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          gutter: 10,
          style: {"margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  maxlength: "5000",
                  modelValue: formData.value.correctText,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.correctText) = $event)),
                  type: "textarea",
                  rows: 6,
                  placeholder: "请输入作文文本，文本拍照二选一即可"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          gutter: 10,
          style: {"margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-box",
                  "file-list": fileList.value,
                  "onUpdate:fileList": _cache[3] || (_cache[3] = ($event: any) => ((fileList).value = $event)),
                  action: "#",
                  max: 5,
                  "list-type": "picture-card",
                  "http-request": httpRequest,
                  "on-preview": handlePictureCardPreview,
                  "on-remove": handleRemove
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_icon, { size: "24" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Camera)
                          ]),
                          _: 1
                        })
                      ]),
                      _cache[9] || (_cache[9] = _createElementVNode("div", null, "作文上传", -1))
                    ])
                  ]),
                  _: 1
                }, 8, ["file-list"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "correct-tip" }, [
          _createElementVNode("span", { class: "activeColor" }, "*提示："),
          _createElementVNode("span", null, "请把上传单页作文竖着完整的作文图片，确保所有文字都入镜。竖屏的作文图片一次上传一页，可多次上传，最多可上传5页。")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          disabled: aiStart.value,
          style: {"width":"100%"},
          color: "#ef8b25",
          class: "footer-btn1",
          onClick: submitEvent
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("AI作文批改")
          ])),
          _: 1,
          __: [11]
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (!Object.keys(_unref(resultInfo)).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "评阅结果"))
        : _createCommentVNode("", true),
      (Object.keys(_unref(resultInfo)).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_el_tabs, {
              modelValue: activeName.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeName).value = $event)),
              class: "demo-tabs",
              onTabChange: resultTabChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_tab_pane, {
                    label: item.label,
                    name: item.value,
                    key: item.value
                  }, null, 8, ["label", "name"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", { onClick: transVoice }, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Microphone)
                  ]),
                  _: 1
                }),
                (voiceStatus.value==2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "语音继续"))
                  : (voiceStatus.value==1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "语音暂停"))
                    : (voiceStatus.value==4)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "语音重播"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, "转语音"))
              ]),
              _createElementVNode("div", { onClick: exportEvent }, " 导出结果 ")
            ])
          ]))
        : _createCommentVNode("", true),
      (Object.keys(_unref(resultInfo)).length && activeName.value!='04')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_unref(resultInfo).Ⅰ && _unref(resultInfo).Ⅰ.length && dataFormat('Ⅰ'))
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(resultInfo).Ⅰ, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "",
                    key: 'Ⅰ'+index,
                    innerHTML: item
                  }, null, 8, _hoisted_16))
                }), 128))
              : _createCommentVNode("", true),
            (_unref(resultInfo).Ⅱ && _unref(resultInfo).Ⅱ.length && dataFormat('Ⅱ'))
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(resultInfo).Ⅱ, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "",
                    key: 'Ⅱ'+index,
                    innerHTML: item
                  }, null, 8, _hoisted_17))
                }), 128))
              : _createCommentVNode("", true),
            (_unref(resultInfo).Ⅲ && _unref(resultInfo).Ⅲ.length && dataFormat('Ⅲ'))
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(resultInfo).Ⅲ, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "",
                    key: 'Ⅲ'+index,
                    innerHTML: item
                  }, null, 8, _hoisted_18))
                }), 128))
              : _createCommentVNode("", true),
            (_unref(resultInfo).Ⅳ && _unref(resultInfo).Ⅳ.length && dataFormat('Ⅳ'))
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_unref(resultInfo).Ⅳ, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "",
                    key: 'Ⅳ'+index,
                    innerHTML: item
                  }, null, 8, _hoisted_19))
                }), 128))
              : _createCommentVNode("", true),
            (_unref(resultInfo).Ⅴ && _unref(resultInfo).Ⅴ.length && dataFormat('Ⅴ'))
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_unref(resultInfo).Ⅴ, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "",
                    key: 'Ⅴ'+index,
                    innerHTML: item
                  }, null, 8, _hoisted_20))
                }), 128))
              : _createCommentVNode("", true),
            (_unref(resultInfo).Ⅵ && _unref(resultInfo).Ⅵ.length && dataFormat('Ⅵ'))
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(_unref(resultInfo).Ⅵ, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "",
                    key: 'Ⅵ'+index
                  }, [
                    _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_21),
                    (_unref(resultInfo).Ⅶ && _unref(resultInfo).Ⅶ.length>=_unref(resultInfo).Ⅵ.length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          innerHTML: _unref(resultInfo).Ⅶ[index]
                        }, null, 8, _hoisted_22))
                      : _createCommentVNode("", true),
                    (_unref(resultInfo).Ⅷ && _unref(resultInfo).Ⅷ.length>=_unref(resultInfo).Ⅵ.length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          innerHTML: _unref(resultInfo).Ⅷ[index]
                        }, null, 8, _hoisted_23))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!Object.keys(_unref(resultInfo)).length && _unref(aiMessage) && _unref(aiMessage)!='{}')
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            innerHTML: _unref(aiMessage),
            class: "page-inner-box"
          }, null, 8, _hoisted_24))
        : _createCommentVNode("", true),
      (!_unref(aiMessage))
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[13] || (_cache[13] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1),
            _createElementVNode("div", null, "结果将在此处展示！", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    (showPreview.value)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": previewFileArr.value,
          "show-progress": "",
          "initial-index": previewIndex.value,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (showPreview.value = false))
        }, null, 8, ["url-list", "initial-index"]))
      : _createCommentVNode("", true),
    (popupShow.value)
      ? (_openBlock(), _createBlock(AIpopup, {
          key: 1,
          popupShow: popupShow.value,
          cancelShow: false,
          onCancel: aiCancel
        }, null, 8, ["popupShow"]))
      : _createCommentVNode("", true)
  ]))
}
}

})